import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import YourTimeImageAndContent from 'src/app/organisms/Homepage/YourTimeImageAndContent/YourTimeImageAndContent';

const YourTime = (): JSX.Element => (
  <SectionLayout
    padding={['spacing-7xl', 'spacing-xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
    maxWidth='width-3xl'
  >
    <YourTimeImageAndContent />
  </SectionLayout>
);

export default YourTime;
